module.exports = __webpack_public_path__ + "static/img/paymentsuccess.2e5c972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/paymentsuccess.jpg
// module id = Kb8p
// module chunks = 1